import { useContext } from 'react'

import { TableGridContext } from '@component/Layout/TableGrid'

import type { ITableGridContext } from '@base/@types/components/Layout/TableGrid'

export default function useTableScrolluseTable(): ITableGridContext {
  const context = useContext(TableGridContext)

  return context
}
